import React, {useState} from "react"
import {useAuth} from "../contexts/AuthContext"
import {Link as RouterLink, useHistory} from "react-router-dom"
import {Box, Button, Card, CardContent, Link, TextField} from "@mui/material";
import Alert from '@mui/material/Alert';

export default function Login() {
    const {login, resendEmailVerification} = useAuth()
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)
    const [allowReverify, setAllowReverify] = useState(false)
    const history = useHistory()

    const handleSubmit = async (e) => {
        e.preventDefault()
        const email = document.getElementById('email').value;
        const password = document.getElementById('password').value;
        try {
            setError("")
            setLoading(true)
            const result = await login(email, password)
            if (result.user.emailVerified) {
                history.push("/")
            } else {
                setAllowReverify(true)
                setError("Account not verified. Please check your email.")
            }
        } catch (e) {
            console.log(e)
            setError(e.message)
        }
        setLoading(false)
    }

    //Handles if the user hits the enter key while typing
    const handleEnter = (e) => {
        if (e.key === "Enter") {
            handleSubmit(e)
        }
    }

    const handleResend = () => {
        const email = document.getElementById('email').value;
        const password = document.getElementById('password').value;
        resendEmailVerification(email, password)
    }

    return (
        <Box>
            <Card>
                <CardContent>
                    {/*<Typography variant={'h2'}>Log In</Typography>*/}
                    {error && <Alert severity="error">{error}</Alert>}
                    <Box m={2}>
                        <TextField id="email" autoComplete='off' variant="outlined" label="Email..." onKeyPress={handleEnter}/>
                    </Box>
                    <Box m={2}>
                        <TextField id="password" variant="outlined" label="Password..." type="password"
                                   onKeyPress={handleEnter}/>
                    </Box>
                    <Box>
                        <Button disabled={loading} onClick={handleSubmit} variant="contained" color="primary">
                            Log In
                        </Button>
                    </Box>

                    <Box m={2}>
                        <Link component={RouterLink} to="/signup">Sign Up</Link>
                    </Box>
                    {allowReverify &&
                    <Button variant="outlined" m={2} onClick={handleResend}>Resend Verification Email</Button>
                    }

                </CardContent>
            </Card>
        </Box>
    )
}
